import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ChipToken, { getChipColor } from "../../components/ChipToken";
import { axiosRequest } from "../../utility/axios";
import { apiBaseUrl } from "../../constant/endpoint";

export const calcAmount = (denom, qty) => Number(denom || 0) * Number(qty || 0);

const pad = (n) => String(n).padStart(2, "0");
export const nowStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

// Regular (non-promo) chip stock, one row per denomination
export const loadRegularChips = async (token) => {
  try {
    const res = await axiosRequest("GET", `${apiBaseUrl}/chips`, token);
    const chips = Array.isArray(res?.data) ? res.data : (res?.data?.data ?? []);
    const seen = {};
    return chips
      .filter((c) => (c.chip_type || "REGULAR") !== "PROMO")
      .filter((c) => (seen[c.denomination] ? false : (seen[c.denomination] = true)))
      .sort((a, b) => a.denomination - b.denomination);
  } catch {
    return [];
  }
};

// capByStock: issuing chips — qty limited by counter stock.
// Returning chips doesn't depend on counter stock, so no cap there.
export const FloatChipTable = ({ chips, qty, setQty, qtyLabel, capByStock = false }) => (
  <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden", mb: 3 }}>
    <Table size="small">
      <TableHead>
        <TableRow sx={{ backgroundColor: "#1c2433" }}>
          <TableCell sx={{ fontWeight: 700 }}>Denomination</TableCell>
          {capByStock && <TableCell sx={{ fontWeight: 700 }} align="center">Stock Available</TableCell>}
          <TableCell sx={{ fontWeight: 700 }} align="center">{qtyLabel}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {chips.length === 0 ? (
          <TableRow>
            <TableCell colSpan={3} align="center" sx={{ color: "text.secondary" }}>No chip stock found</TableCell>
          </TableRow>
        ) : (
          chips.map((chip) => {
            const q = qty[chip.denomination] || "";
            const over = capByStock && Number(q) > chip.quantity;
            return (
              <TableRow key={chip._id || chip.denomination} sx={{ backgroundColor: getChipColor(chip.denomination).bg + "18" }}>
                <TableCell><ChipToken denomination={chip.denomination} size={40} /></TableCell>
                {capByStock && (
                  <TableCell align="center">
                    <Typography fontWeight={600} color={chip.quantity === 0 ? "error" : "success.main"}>{chip.quantity}</Typography>
                  </TableCell>
                )}
                <TableCell align="center" sx={{ width: 120 }}>
                  <TextField
                    size="small" type="number" value={q}
                    onChange={(e) => setQty({ ...qty, [chip.denomination]: e.target.value })}
                    inputProps={{ min: 0, ...(capByStock ? { max: chip.quantity } : {}) }}
                    disabled={capByStock && chip.quantity === 0}
                    error={over}
                    helperText={over ? `Max ${chip.quantity}` : ""}
                    sx={{ width: 90, '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': { display: 'none' }, '& input[type=number]': { MozAppearance: 'textfield' } }}
                  />
                </TableCell>
              </TableRow>
            );
          })
        )}
      </TableBody>
    </Table>
  </Paper>
);
